import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { isPlatformBrowser } from '@angular/common';
import { EMPTY, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserReactionService {
  private http       = inject(HttpClient);
  private platformId = inject(PLATFORM_ID);
  private baseUrl    = `${environment.apiUrl}`;

  getUserReactions(userName: string, page = 1, limit = 9): Observable<any> {
    if (!isPlatformBrowser(this.platformId)) return EMPTY;
    const params = new HttpParams()
      .set('page',  page.toString())
      .set('limit', limit.toString());
    return this.http.get(`${this.baseUrl}/reactions/user/${userName}`, { params });
  }
}
